import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fromJS, List, Map } from "immutable";
import { createSelector } from "reselect";
export function l10nReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "L10N/LOCALE_SET":
      return _objectSpread(_objectSpread({}, state), {}, {
        locale: action.payload.locale,
        translations: action.payload.translations
      });
    default:
      return state;
  }
}
export var getPlainTranslations = function getPlainTranslations(state) {
  var _state$l10n;
  return (_state$l10n = state.l10n) === null || _state$l10n === void 0 ? void 0 : _state$l10n.translations;
};
export var getTranslations = createSelector([getPlainTranslations], function (translations) {
  return translations ? fromJS(translations) : Map();
});
var getTranslationCodes = createSelector([getTranslations], function (translations) {
  return List(translations.keys());
});
export var getCurrentLocale = function getCurrentLocale(state) {
  var _state$l10n2;
  return state === null || state === void 0 || (_state$l10n2 = state.l10n) === null || _state$l10n2 === void 0 ? void 0 : _state$l10n2.locale;
};
export var newTranslate = createSelector([getTranslations], function (translations) {
  return function (code) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return translations.get(code, "MISSING code \"".concat(code, "\"")).replace(/\{(.*?)\}/g, function (_, key) {
      return key in data ? data[key] : "{".concat(key, "}");
    });
  };
});
export var newTranslationAvailable = createSelector([getTranslations], function (translations) {
  return function (code) {
    var translation = translations.get(code);
    return typeof translation === "string" && translation.trim().length > 0;
  };
});
export var createDynamicListSelector = function createDynamicListSelector(mapping) {
  return createSelector([getTranslationCodes, getTranslations], function (translationCodes, translations) {
    var suffix = /_(\d+)$/;
    var codePrefix = function codePrefix(code) {
      return code.replace(suffix, "");
    };
    var codeSuffix = function codeSuffix(code) {
      return suffix.exec(code)[1];
    };
    var mappingKeys = Object.keys(mapping);
    var objects = translationCodes
    // Remove all codes that don't have an id suffix
    .filter(function (code) {
      return code.match(suffix);
    })

    // Remove all codes that are not part of the mapping
    .filter(function (code) {
      return mappingKeys.includes(codePrefix(code));
    })

    // Group codes by id suffix
    .groupBy(codeSuffix).entrySeq()

    // Convert each group of translation codes into mapped objects
    .map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        id = _ref2[0],
        group = _ref2[1];
      return group.reduce(function (acc, code) {
        return acc.set(mapping[codePrefix(code)], translations.get(code).trim());
      }, Map([["id", id]]));
    })

    // Sort objects by id
    .sortBy(function (map) {
      return parseInt(map.get("id"), 10);
    });

    // Convert sequence to immutable List
    return List(objects);
  });
};
export var newDateToMonthName = function newDateToMonthName(mlCodes) {
  return createSelector([newTranslate], function (translate) {
    return function (date) {
      var month = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"][date.getMonth()];
      var mlCode = mlCodes[month];
      return translate(mlCode);
    };
  });
};
export var newDateToAbbreviatedWeekdayName = function newDateToAbbreviatedWeekdayName(mlCodes) {
  return createSelector([newTranslate], function (translate) {
    return function (date) {
      var weekday = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][date.getDay()];
      var mlCode = mlCodes[weekday];
      return translate(mlCode);
    };
  });
};